// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.added-players-list__subtitle.baloa-normal-text{
    color: var(--basic-gray-color) !important;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    margin-bottom: var(--space);
}

.added-players-list__container{
    width: 90%;
    margin-bottom: calc(var(--space)*8);
    padding: 0 var(--space-x3);
}

.added-players-list__member{
    display: flex;
    align-items: center;
}

.added-players-list__member__member {
    display: flex;
    align-items: center;
    width: 35%;
    margin-bottom: var(--space-half);
}

.added-players-list__member-photo{
   margin-right: calc( var(--space-half) /2);
   border-radius: 50%;
   background-color: turquoise;  
   display: flex;
   align-items: center;
   /*
   height: 36px;
   width: 36px;
   */

   
}

.added-players-list__member-photo .icon-ball{
   color: var( --white-color );
   font-size: calc((var(--space)/4)*7);/*28px;*/
   border-radius: 50%;
   padding: calc(var(--space)/4);/*4px;*/
}

.league-search-profile__icon{
   margin-right: calc( var(--space-half) /2);
   border-radius: 50%;
   background-color: turquoise;
}

.league-search-profile__icon .icon-ball {
  color: var( --white-color );
  font-size: calc((var(--space)/4)*7);/*28px;*/
  border-radius: 50%;
  padding: calc(var(--space)/4);/*4px;*/
}

.added-players-list__member-photo img{
    border-radius: 50%;
    width: calc((var(--space-quarter)*9));

}

.added-players-list__member-data{
    /* display: inline; */
}

.added-players-list__member-data__role {
    display: flex;
    margin-inline-start: var(--space-x2);
    align-items: center;
}

.added-players-list__member-data__rol {
    height: var(--space-x2);
    background: var(--border-card-color);
    border-radius: var(--space-quarter);
    padding-block-start: var(--space-quarter);
}

.added-players-list__member-data__rol__title {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--primary-very-dark-color);
    margin: var(--space);
}

.added-players-list__member-data__player {
    display: flex;
}

.added-players-list__member-data__player__number {
    width: var(--space-x3);
    height: var(--space-x2);
    background: var(--disabled-sb-font-color);
    border-radius: var(--space-quarter);
    margin-inline-start: var(--space);
    margin-inline-end: var(--space);
    padding-block-start: var(--space-quarter);
}

.added-players-list__member-data__player__number__number {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color);
    margin: var(--space);
}

.added-players-list__member-data__player__position {
    width: 60%;
    height: var(--space-x2);
    background: var( --disabled-sb-font-color);
    border-radius: var(--space-quarter);
    padding-block-start: var(--space-quarter);
}

.added-players-list__member-data__player__position__title {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color);
    padding-inline-start: var(--space-half);
}

.added-players-list__member-name.baloa-body-2{
    color: var(--primary-dark-color) !important;
}

.added-players-list__close-button{
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: var(--space);
}

.added-players-list__close-button .icon-x{
    background-color: var(--primary-light-color);
    border-radius: 50%;
    font-size: var(--space);
    padding: var(--space-quarter);
}

.added-players-list__close-button .icon-x:hover{
    background-color: var(--basic-gray-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-added-players-list/LeagueAddedPlayersListComponent.styles.css"],"names":[],"mappings":";AACA;IACI,yCAAyC;IACzC,+BAA+B;IAC/B,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gCAAgC;AACpC;;AAEA;GACG,yCAAyC;GACzC,kBAAkB;GAClB,2BAA2B;GAC3B,aAAa;GACb,mBAAmB;GACnB;;;IAGC;;;AAGJ;;AAEA;GACG,2BAA2B;GAC3B,mCAAmC,CAAC,QAAQ;GAC5C,kBAAkB;GAClB,6BAA6B,CAAC,OAAO;AACxC;;AAEA;GACG,yCAAyC;GACzC,kBAAkB;GAClB,2BAA2B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC,CAAC,QAAQ;EAC5C,kBAAkB;EAClB,6BAA6B,CAAC,OAAO;AACvC;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;;AAEzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yCAAyC;IACzC,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;IAC/B,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,0CAA0C;IAC1C,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":["\n.added-players-list__subtitle.baloa-normal-text{\n    color: var(--basic-gray-color) !important;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    margin-bottom: var(--space);\n}\n\n.added-players-list__container{\n    width: 90%;\n    margin-bottom: calc(var(--space)*8);\n    padding: 0 var(--space-x3);\n}\n\n.added-players-list__member{\n    display: flex;\n    align-items: center;\n}\n\n.added-players-list__member__member {\n    display: flex;\n    align-items: center;\n    width: 35%;\n    margin-bottom: var(--space-half);\n}\n\n.added-players-list__member-photo{\n   margin-right: calc( var(--space-half) /2);\n   border-radius: 50%;\n   background-color: turquoise;  \n   display: flex;\n   align-items: center;\n   /*\n   height: 36px;\n   width: 36px;\n   */\n\n   \n}\n\n.added-players-list__member-photo .icon-ball{\n   color: var( --white-color );\n   font-size: calc((var(--space)/4)*7);/*28px;*/\n   border-radius: 50%;\n   padding: calc(var(--space)/4);/*4px;*/\n}\n\n.league-search-profile__icon{\n   margin-right: calc( var(--space-half) /2);\n   border-radius: 50%;\n   background-color: turquoise;\n}\n\n.league-search-profile__icon .icon-ball {\n  color: var( --white-color );\n  font-size: calc((var(--space)/4)*7);/*28px;*/\n  border-radius: 50%;\n  padding: calc(var(--space)/4);/*4px;*/\n}\n\n.added-players-list__member-photo img{\n    border-radius: 50%;\n    width: calc((var(--space-quarter)*9));\n\n}\n\n.added-players-list__member-data{\n    /* display: inline; */\n}\n\n.added-players-list__member-data__role {\n    display: flex;\n    margin-inline-start: var(--space-x2);\n    align-items: center;\n}\n\n.added-players-list__member-data__rol {\n    height: var(--space-x2);\n    background: var(--border-card-color);\n    border-radius: var(--space-quarter);\n    padding-block-start: var(--space-quarter);\n}\n\n.added-players-list__member-data__rol__title {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--primary-very-dark-color);\n    margin: var(--space);\n}\n\n.added-players-list__member-data__player {\n    display: flex;\n}\n\n.added-players-list__member-data__player__number {\n    width: var(--space-x3);\n    height: var(--space-x2);\n    background: var(--disabled-sb-font-color);\n    border-radius: var(--space-quarter);\n    margin-inline-start: var(--space);\n    margin-inline-end: var(--space);\n    padding-block-start: var(--space-quarter);\n}\n\n.added-players-list__member-data__player__number__number {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color);\n    margin: var(--space);\n}\n\n.added-players-list__member-data__player__position {\n    width: 60%;\n    height: var(--space-x2);\n    background: var( --disabled-sb-font-color);\n    border-radius: var(--space-quarter);\n    padding-block-start: var(--space-quarter);\n}\n\n.added-players-list__member-data__player__position__title {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color);\n    padding-inline-start: var(--space-half);\n}\n\n.added-players-list__member-name.baloa-body-2{\n    color: var(--primary-dark-color) !important;\n}\n\n.added-players-list__close-button{\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    margin-right: var(--space);\n}\n\n.added-players-list__close-button .icon-x{\n    background-color: var(--primary-light-color);\n    border-radius: 50%;\n    font-size: var(--space);\n    padding: var(--space-quarter);\n}\n\n.added-players-list__close-button .icon-x:hover{\n    background-color: var(--basic-gray-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
